import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Loading } from '@/components';
import { EventFractional } from '@/model/EventFractional';
import { EventFractionalReportUI } from './ui';

interface EventFractionalReportProps {
  eventId: string;
}

export const EventFractionalReportScreen: React.FC<EventFractionalReportProps> = ({ eventId }) => {
  const [state, setState] = useState<States>(States.default);
  const [ticketsFractional, setTicketsFractional] = useState<EventFractional[]>([]);

  const getEventFractionls = async (): Promise<void> => {
    if (eventId) {
      try {
        setState(States.loading);
        const { data } = await api.get<EventFractional[]>(`event/report/${eventId}/fractional`);
        if (data) {
          setTicketsFractional(data);
        }
      } catch (error) {
        const err = error as AxiosError;
        toast.error(err.message);
      } finally {
        setState(States.default);
      }
    }
  };
  useEffect(() => {
    getEventFractionls();
  }, []);
  return (
    <>
      <Loading isVisible={state === 'loading'} />
      <EventFractionalReportUI ticketsFractional={ticketsFractional} />
    </>
  );
};
